import type { ImgHTMLAttributes } from "react";

const ALLOWED_HOSTS = ["blob.core.windows.net"] as const;

export function isSafeImageUrl(src: string | null | undefined): boolean {
  if (!src) return false;
  if (src.startsWith("/") || src.startsWith("./")) return true;
  try {
    const url = new URL(src);
    if (url.protocol !== "https:" && url.protocol !== "http:") return false;
    return ALLOWED_HOSTS.some((host) => url.hostname.endsWith(host));
  } catch {
    return false;
  }
}

export function SafeImage({ src, alt, ...props }: ImgHTMLAttributes<HTMLImageElement>) {
  if (!isSafeImageUrl(src)) {
    return <span className="type-body-sm italic text-[var(--text-tertiary)]">[image: {alt || "blocked"}]</span>;
  }
  return (
    <img
      src={src}
      alt={alt ?? ""}
      loading="lazy"
      decoding="async"
      className="my-[var(--space-4)] max-w-full rounded-[var(--radius-lg)] shadow-[var(--elev-ring)]"
      {...props}
    />
  );
}
